import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if(!d) return '—'; const m=Math.floor((Date.now()-new Date(d))/60000); return m<1?'just now':m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }

const CHANNELS = [
  { id:'generic',   label:'Generic HTTP',  icon:'🌐', color:'#475569', bg:'#f1f5f9' },
  { id:'slack',     label:'Slack',         icon:'💬', color:'#4a154b', bg:'#f3e8ff' },
  { id:'teams',     label:'Microsoft Teams',icon:'🟦', color:'#1d4ed8', bg:'#dbeafe' },
  { id:'email',     label:'Email',         icon:'📧', color:'#16a34a', bg:'#dcfce7' },
  { id:'splunk',    label:'Splunk',         icon:'🔴', color:'#dc2626', bg:'#fee2e2' },
  { id:'elastic',   label:'Elasticsearch', icon:'🟡', color:'#d97706', bg:'#fef3c7' },
  { id:'pagerduty', label:'PagerDuty',      icon:'🚨', color:'#7c3aed', bg:'#ede9fe' },
];

const EVENTS = [
  'device.enrolled','device.online','device.offline',
  'compliance.failed','compliance.warning','compliance.passed',
  'patch.failed','patch.success','eol.detected',
  'vuln.critical','script.failed','script.success',
  'remote_action.success','remote_action.failed',
  'geofence.entered','geofence.exited',
];

const DEF = { name:'', url:'', channel:'generic', secret:'', events:[], active:true, headers:{} };

export default function Webhooks({ user }) {
  const [webhooks, setWebhooks] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [msg,      setMsg]      = useState({ text:'', type:'' });
  const [showForm, setShowForm] = useState(false);
  const [form,     setForm]     = useState(DEF);
  const [saving,   setSaving]   = useState(false);
  const [testingId,setTestingId]= useState(null);
  const [deliveries, setDeliveries] = useState(null);

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }

  const load = useCallback(async () => {
    try { const r = await axios.get('/api/webhooks', auth()); setWebhooks(r.data); }
    catch(e) { flash(e.response?.data?.error||'Failed to load','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(()=>{ load(); },[load]);

  async function save(e) {
    e.preventDefault(); setSaving(true);
    try {
      await axios.post('/api/webhooks', form, auth());
      flash('Webhook created'); setShowForm(false); setForm(DEF); load();
    } catch(e) { flash(e.response?.data?.error||'Failed','error'); }
    finally { setSaving(false); }
  }

  async function del(id) {
    if (!window.confirm('Delete this webhook?')) return;
    try { await axios.delete(`/api/webhooks/${id}`, auth()); flash('Deleted'); load(); }
    catch(e) { flash('Failed','error'); }
  }

  async function test(id) {
    setTestingId(id);
    try { const r = await axios.post(`/api/webhooks/${id}/test`, {}, auth()); flash(`Test ${r.data.success?'succeeded':'failed'}: ${r.data.statusCode||''}`,(r.data.success?'success':'error')); }
    catch(e) { flash('Test failed','error'); }
    finally { setTestingId(null); }
  }

  async function showDeliveries(id) {
    try { const r = await axios.get(`/api/webhooks/${id}/deliveries`, auth()); setDeliveries(r.data); }
    catch(e) { flash('Failed to load deliveries','error'); }
  }

  function toggleEvent(ev) {
    setForm(f=>({ ...f, events: f.events.includes(ev) ? f.events.filter(x=>x!==ev) : [...f.events,ev] }));
  }

  return (
    <div style={{padding:24}}>
      {msg.text && <div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>{msg.type==='error'?'✘':'✔'} {msg.text}</div>}

      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h2 style={{margin:0,fontSize:20,fontWeight:700}}>Webhooks</h2>
          <p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Send real-time alerts to Slack, Teams, SIEM, email and custom endpoints</p>
        </div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer'}}>+ New Webhook</button>
      </div>

      {/* Channel icons */}
      <div style={{display:'flex',gap:10,marginBottom:20,flexWrap:'wrap'}}>
        {CHANNELS.map(c=><div key={c.id} style={{background:c.bg,borderRadius:8,padding:'8px 14px',fontSize:13,fontWeight:700,color:c.color}}>{c.icon} {c.label}</div>)}
      </div>

      {loading ? <div style={{textAlign:'center',padding:40,color:'#94a3b8'}}>Loading...</div> :
      webhooks.length===0 ? (
        <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}><div style={{fontSize:40,marginBottom:12}}>🔔</div><div style={{fontWeight:600}}>No webhooks yet</div><div style={{fontSize:14,marginTop:8}}>Create one to start receiving real-time alerts</div></div>
      ) : (
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(380px,1fr))',gap:14}}>
          {webhooks.map(wh=>{
            const ch = CHANNELS.find(c=>c.id===wh.channel)||CHANNELS[0];
            return (
              <div key={wh.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:18}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10}}>
                  <div style={{display:'flex',gap:10,alignItems:'center'}}>
                    <div style={{width:36,height:36,borderRadius:8,background:ch.bg,display:'flex',alignItems:'center',justifyContent:'center',fontSize:18}}>{ch.icon}</div>
                    <div>
                      <div style={{fontWeight:700,fontSize:14}}>{wh.name}</div>
                      <div style={{fontSize:11,color:'#64748b',maxWidth:220,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{wh.url}</div>
                    </div>
                  </div>
                  <span style={{background:wh.active?'#dcfce7':'#fee2e2',color:wh.active?'#16a34a':'#dc2626',borderRadius:5,padding:'2px 8px',fontSize:10,fontWeight:700}}>{wh.active?'ACTIVE':'OFF'}</span>
                </div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap',marginBottom:10}}>
                  {(wh.events||[]).slice(0,4).map(ev=><span key={ev} style={{background:'#f1f5f9',color:'#475569',borderRadius:4,padding:'1px 6px',fontSize:10}}>{ev}</span>)}
                  {(wh.events||[]).length>4 && <span style={{background:'#f1f5f9',color:'#94a3b8',borderRadius:4,padding:'1px 6px',fontSize:10}}>+{wh.events.length-4}</span>}
                </div>
                <div style={{fontSize:11,color:'#94a3b8',marginBottom:12}}>Fired {wh.fireCount||0} times · Last {ts(wh.lastFiredAt)}</div>
                <div style={{display:'flex',gap:8}}>
                  <button onClick={()=>test(wh.id)} disabled={testingId===wh.id} style={{flex:1,background:'#1e40af',color:'#fff',border:'none',borderRadius:7,padding:'7px',fontSize:12,fontWeight:600,cursor:'pointer'}}>{testingId===wh.id?'Testing...':'▶ Test'}</button>
                  <button onClick={()=>showDeliveries(wh.id)} style={{flex:1,background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:7,padding:'7px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#475569'}}>📋 History</button>
                  <button onClick={()=>del(wh.id)} style={{background:'#fee2e2',border:'none',borderRadius:7,padding:'7px 10px',fontSize:12,cursor:'pointer',color:'#dc2626'}}>🗑</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {showForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:560,maxWidth:'95vw',maxHeight:'90vh',overflow:'auto'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Webhook</h3>
            <form onSubmit={save}>
              <div style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Name*</label>
                <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} required style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              <div style={{marginBottom:14}}><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Webhook URL*</label>
                <input value={form.url} onChange={e=>setForm({...form,url:e.target.value})} required placeholder="https://hooks.slack.com/..." style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Channel</label>
                  <select value={form.channel} onChange={e=>setForm({...form,channel:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    {CHANNELS.map(c=><option key={c.id} value={c.id}>{c.icon} {c.label}</option>)}
                  </select></div>
                <div><label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4}}>Secret (HMAC)</label>
                  <input value={form.secret||''} onChange={e=>setForm({...form,secret:e.target.value})} placeholder="Optional signing secret" style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} /></div>
              </div>
              <div style={{marginBottom:20}}>
                <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:8}}>Events to trigger</label>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {EVENTS.map(ev=>(
                    <button key={ev} type="button" onClick={()=>toggleEvent(ev)} style={{padding:'4px 10px',borderRadius:5,border:'1px solid',fontSize:11,cursor:'pointer',fontWeight:600,background:form.events.includes(ev)?'#1e40af':'#f1f5f9',color:form.events.includes(ev)?'#fff':'#475569',borderColor:form.events.includes(ev)?'#1e40af':'#e2e8f0'}}>
                      {ev}
                    </button>
                  ))}
                </div>
                <div style={{display:'flex',gap:8,marginTop:8}}>
                  <button type="button" onClick={()=>setForm({...form,events:[...EVENTS]})} style={{fontSize:11,padding:'3px 10px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:5,cursor:'pointer'}}>All</button>
                  <button type="button" onClick={()=>setForm({...form,events:[]})} style={{fontSize:11,padding:'3px 10px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:5,cursor:'pointer'}}>None</button>
                </div>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" disabled={saving} style={{padding:'10px 20px',background:saving?'#94a3b8':'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:saving?'default':'pointer'}}>{saving?'Creating...':'Create'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {deliveries && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,width:600,maxWidth:'95vw',maxHeight:'80vh',display:'flex',flexDirection:'column'}}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #f1f5f9',display:'flex',justifyContent:'space-between'}}>
              <span style={{fontWeight:700,fontSize:16}}>Delivery History</span>
              <button onClick={()=>setDeliveries(null)} style={{background:'none',border:'none',fontSize:18,cursor:'pointer',color:'#64748b'}}>✕</button>
            </div>
            <div style={{flex:1,overflow:'auto',padding:16}}>
              {deliveries.length===0 ? <div style={{textAlign:'center',padding:32,color:'#94a3b8'}}>No deliveries yet</div> :
              deliveries.map(d=>(
                <div key={d.id} style={{border:'1px solid #e2e8f0',borderRadius:8,padding:'12px 14px',marginBottom:8}}>
                  <div style={{display:'flex',justifyContent:'space-between',marginBottom:4}}>
                    <span style={{fontWeight:600,fontSize:13}}>{d.event}</span>
                    <div style={{display:'flex',gap:8,alignItems:'center'}}>
                      <span style={{background:d.success?'#dcfce7':'#fee2e2',color:d.success?'#16a34a':'#dc2626',borderRadius:4,padding:'1px 7px',fontSize:11,fontWeight:700}}>{d.success?'OK':d.statusCode||'FAIL'}</span>
                      <span style={{fontSize:11,color:'#94a3b8'}}>{d.durationMs}ms · {ts(d.createdAt)}</span>
                    </div>
                  </div>
                  {d.response && <div style={{fontSize:11,color:'#64748b',fontFamily:'monospace',background:'#f8fafc',padding:'4px 8px',borderRadius:4,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{d.response}</div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
